import { createPerimeter } from 'vue-kindergarten';
import { isRole } from '../utilities/roleUtilities';

export const UsersPerimeter = createPerimeter({
    purpose: 'users',

    can: {
        read () {
            return isRole.admin(this.child)
                || isRole.shop_owner(this.child);
        },
        // only admin can see admin options
        viewAdminOptions () {
            return isRole.admin(this.child);
        },
        add () {
            return isRole.admin(this.child)
                || isRole.shop_owner(this.child);
        },

        update () {
            return isRole.admin(this.child)
                || isRole.shop_owner(this.child);
        }
    }
});